import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../components/Particle";

const calculateExperience = () => {
    const startDate = new Date(2023, 0, 1); // January 1, 2023
    const today = new Date();

    let years = today.getFullYear() - startDate.getFullYear();
    let months = today.getMonth() - startDate.getMonth();

    if (today.getDate() < startDate.getDate()) {
        months--;
    }

    if (months < 0) {
        years--;
        months += 12;
    }

    return `${years} Years ${months} Months`;
};

const totalExperience = calculateExperience();

const Experience = () => {
    return (
        <Container
            fluid
            id="experience"
            className="experience-section"
            style={{
                position: "relative",
                zIndex: 2,
                color: "#ffffff",
                minHeight: "100vh",
                paddingTop: "100px",
            }}
        >
            <Particle />

            <Container>

                {/* Heading */}
                <Row>
                    <Col
                        md={12}
                        className="experience-heading"
                        style={{
                            position: "relative",
                            zIndex: 2,
                            textAlign: "center",
                            color: "#ffffff",
                        }}
                    >
                        <h1>
                            MY <span className="yellow">EXPERIENCE</span>
                        </h1>

                        <p className="text-light">
                            My professional journey and technical experience.
                        </p>

                        <p className="text-light mt-3">
                            Total Experience:{" "}
                            <span className="yellow">
                                {totalExperience}
                            </span>
                        </p>
                    </Col>
                </Row>

                {/* Career Highlights */}
                <Row className="justify-content-center mt-4">
                    <Col md={10} lg={9}>
                        <div className="experience-card-view">
                            <div className="text-center">
                                <h3 className="experience-company">
                                    Career Highlights
                                </h3> <br />

                                <p className="text-light mb-0">
                                    Frontend Development • MERN Stack •
                                    Technical Training • REST API Integration •
                                    DSA
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Experience Timeline */}
                <Row className="justify-content-center mt-5">
                    <Col md={10} lg={9}>

                        {/* Amypo Technologies */}
                        <div className="experience-item">

                            <div className="experience-dot"></div>

                            <div className="experience-card-view">

                                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">

                                    <div>
                                        <h2 className="experience-title">
                                            Technical Trainer
                                        </h2>

                                        <h4 className="experience-company">
                                            Amypo Technologies
                                        </h4>
                                    </div>

                                    <span className="experience-date">
                                        Aug 2026 – Present
                                    </span>

                                </div>

                                <hr />

                                <ul>
                                    <li>
                                        Deliver technical training in{" "}
                                        <b>
                                            Java, Python, React, JavaScript,
                                            and frontend development
                                        </b>.
                                    </li>

                                    <li>
                                        Explain{" "}
                                        <b>
                                            OOP, DSA, React concepts, and
                                            web development
                                        </b>{" "}
                                        through practical coding examples.
                                    </li>

                                    <li>
                                        Guide students through hands-on coding,
                                        projects,{" "}
                                        <b>REST API and Axios integration</b>,
                                        and application development.
                                    </li>

                                    <li>
                                        Prepare coding assessments, practice
                                        questions, and structured learning
                                        materials.
                                    </li>

                                    <li>
                                        Track learner progress and provide
                                        technical guidance, debugging support,
                                        and problem-solving assistance.
                                    </li>
                                </ul>

                                <h5 className="experience-company mt-4">
                                    Technologies
                                </h5>

                                <div className="d-flex flex-wrap gap-2 mt-3">
                                    <span className="experience-tag">
                                        Java
                                    </span>

                                    <span className="experience-tag">
                                        Python
                                    </span>

                                    <span className="experience-tag">
                                        React
                                    </span>

                                    <span className="experience-tag">
                                        JavaScript
                                    </span>

                                    <span className="experience-tag">
                                        TypeScript
                                    </span>

                                    <span className="experience-tag">
                                        Node.js
                                    </span>

                                    <span className="experience-tag">
                                        MongoDB
                                    </span>

                                    <span className="experience-tag">
                                        REST API
                                    </span>

                                    <span className="experience-tag">
                                        Axios
                                    </span>

                                    <span className="experience-tag">
                                        DSA
                                    </span>
                                </div>

                            </div>
                        </div>

                        {/* Nurture Infotech */}
                        <div className="experience-item">

                            <div className="experience-dot"></div>

                            <div className="experience-card-view">

                                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">

                                    <div>
                                        <h2 className="experience-title">
                                            Frontend Developer | Technical Trainer
                                        </h2>

                                        <h4 className="experience-company">
                                            Nurture Infotech, Erode
                                        </h4>
                                    </div>

                                    <span className="experience-date">
                                        Jan 2023 – July 2026
                                    </span>

                                </div>

                                <hr />

                                <ul>
                                    <li>
                                        Developed responsive and
                                        high-performance applications using{" "}
                                        <b>
                                            React, Next.js, TypeScript,
                                            and Tailwind CSS
                                        </b>.
                                    </li>

                                    <li>
                                        Built reusable components and
                                        implemented{" "}
                                        <b>
                                            REST APIs, React Hooks, Redux,
                                            SSR, and SSG
                                        </b>.
                                    </li>

                                    <li>
                                        Worked with{" "}
                                        <b>
                                            Node.js, Express.js, and MongoDB
                                        </b>{" "}
                                        for frontend and backend integration.
                                    </li>

                                    <li>
                                        Used{" "}
                                        <b>
                                            Git, GitHub, and CI/CD
                                        </b>{" "}
                                        for version control, collaboration,
                                        and application deployment.
                                    </li>

                                    <li>
                                        Trained learners in{" "}
                                        <b>
                                            HTML, CSS, JavaScript, React,
                                            Node.js, MongoDB, and REST APIs
                                        </b>.
                                    </li>
                                </ul>

                                <h5 className="experience-company mt-4">
                                    Technologies
                                </h5>

                                <div className="d-flex flex-wrap gap-2 mt-3">
                                    <span className="experience-tag">
                                        React
                                    </span>

                                    <span className="experience-tag">
                                        Next.js
                                    </span>

                                    <span className="experience-tag">
                                        TypeScript
                                    </span>

                                    <span className="experience-tag">
                                        JavaScript
                                    </span>

                                    <span className="experience-tag">
                                        Tailwind CSS
                                    </span>

                                    <span className="experience-tag">
                                        Node.js
                                    </span>

                                    <span className="experience-tag">
                                        Express.js
                                    </span>

                                    <span className="experience-tag">
                                        MongoDB
                                    </span>

                                    <span className="experience-tag">
                                        Redux
                                    </span>

                                    <span className="experience-tag">
                                        REST API
                                    </span>

                                    <span className="experience-tag">
                                        Git / GitHub
                                    </span>

                                    <span className="experience-tag">
                                        CI/CD
                                    </span>

                                </div>

                            </div>
                        </div>

                    </Col>
                </Row>

            </Container>
        </Container>
    );
};

export default Experience;